<template>
  <div class="text-center">
        <!-- <InfoCard></InfoCard> -->
        <p class="font-bold relative inline-block font-size margin-auto relative z-10">  {{propertyListLength}} results </p>

   <div v-bind:key="providers.name" v-for="providers in propertylist">
        <div v-bind:key="kit.id" v-for="kit in providers"  class="mt-8 mb-8 bg-white  p-4 rounded shadow-md">
          <div class="w-full h-full mt-5">
            <div class="w-full lg:w-2/3 lg:text-left block lg:inline-block border-b-2 lg:border-b-0 lg:border-r-2 lg:border-gray-200">
                <img class="block lg:inline-block mr-10 rounded-lg w-full h-64 lg:w-56" src="../../assets/img/condoimg.jpg" alt="nice condo">
                <div class="block lg:mt-0 mt-10 lg:inline-block align-top w-full lg:w-2/3">
              <div class="block uppercase text-xl tracking-wide text-sm text-gray-600 font-bold">{{kit.name}} </div>
              <a href="#" class="block mt-1 text-lg leading-tight font-semibold text-gray-900">By: {{kit.developerName}}</a>
              <p class="mt-2 w-full h-32 block text-gray-600 overflow-hidden break-words">{{kit.desc}}</p>
              </div>

            </div>
            <div class="block lg:inline-block mt-10 lg:mt-0 h-64 w-full lg:w-1/3">
            <div class="lg:ml-10 h-32 ">
           <div v-bind:key="perks.name" v-for="perks in kit.perks" class="mt-2 text-gray-800">
      <i class="fas fa-check-circle p-1 " ></i>
            <span class=" p-1 text-xl font-bold">{{perks.name}}</span>

       </div>
       </div>
         <div class="lg:float-right sm:mt-0 xl:mt-10 relative lg:hidden">
                <a target="_blank"  :href="kit.pdfUrl">
                <button  class="bg-black lg:float-right w-full float-left  mb-2 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded  active:bg-green-700">View Deal
             </button>
                               </a>
                <a target="_blank"  :href="kit.url">
             <button class="bg-black lg:float-right w-full float-left  hover:bg-blue-700 text-white font-bold py-2 px-3 rounded  active:bg-green-700">See Developer
             </button>
                  </a>
              </div>

              <div class="lg:float-right lg:bottom-0 lg:right-0 relative xl:ml-0 lg:ml-2 hidden sm:hidden md:hidden lg:block ">
              <!-- <p class="p-1 text-xl font-bold lg:mt-12 mb-10 lg:mb-0">USD {{kit.price }} $</p> -->
                  <a target="_blank"  :href="kit.pdfUrl">
             <button  class="bg-black lg:float-right w-full float-left  mb-2 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded  active:bg-green-700">View Deal
             </button>
            </a>
            <a target="_blank"  :href="kit.url">
             <button  class="bg-black lg:float-right w-full float-left  hover:bg-blue-700 text-white font-bold py-2 px-3 rounded  active:bg-green-700">See Developer
             </button>
            </a>
              </div>
            </div>
          </div>
       </div>

   </div>
</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
// import InfoCard from "@/components/info-card/InfoCard";

import _ from 'lodash';

export default {
  // components: { InfoCard },
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'illness',
      selected: 'illness',
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  computed: {
    ...mapState('search', ['dropdownMainSelected', 'dropdownIndex', 'mainOptions', 'propertylist']),
    ...mapState('app', ['appTitle']),
    ...mapState('dropdown', ['dropdownMainSelected', 'dropdownOptions', 'dropdownIndex']),
    ...mapGetters('dropdown', ['getDropdown']),
    propertyListLength: {
      get() {
        let results = 0;
        this.propertylist.forEach((element) => {
          results += Number(element.length);
        });
        return results;
      },
    },

  },
  methods: {
    populateCities(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    setCity(name, event) {
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      console.log('blur1!!');
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },
    loadSelect(name, event) {
      event.preventDefault();
      console.log(name);
      this.selectedType = name;
    },
    search(name, event) {
      event.preventDefault();
    },
    handleBlur() {
      this.restOfCities = this.selected;
      console.log('blur2!!');
    },
    away() {
      this.restOfCities = [];
    },
  },
  created() {
    // const self = this;
    // window.addEventListener('click', function(){
    //   // close dropdown when clicked outside
    //   if (self.openBox === true){
    //       self.restOfCities = []
    //   }
    // })
  },
};
</script>
